import { Box, Grid, Stack, Typography } from '@mui/material';

import error403 from 'assets/images/maintenance/img-error-403.png';

type Props = {};

const UnauthorizedPage = (props: Props) => {
  return (
    <>
      <Grid
        container
        spacing={10}
        direction="column"
        alignItems="center"
        justifyContent="center"
        sx={{ minHeight: '100vh', pt: 2, pb: 1, overflow: 'hidden' }}
      >
        <Grid item xs={12}>
          <Stack direction="row">
            <Grid item>
              <Box sx={{ width: { xs: 250, sm: 590 }, height: { xs: 130, sm: 300 } }}>
                <img src={error403} alt="error 404" style={{ width: '100%', height: '100%' }} />
              </Box>
            </Grid>
          </Stack>
        </Grid>
        <Grid item xs={12}>
          <Stack spacing={2} justifyContent="center" alignItems="center">
            <Typography variant="h1">Unauthorized!</Typography>
            <Typography color="textSecondary" align="center" sx={{ width: { xs: '73%', sm: '61%' } }}>
              You’re not authorized to access this page. Please contact the administrator.
            </Typography>
          </Stack>
        </Grid>
      </Grid>
    </>
  );
};

export default UnauthorizedPage;
